import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  useHistory
} from 'react-router-dom';

import {
  HContainerH,
  Image,
  JourneyProvider,
  Spinner,
  Text,
  VContainer,
  VContainerH,
  VFillContainer
} from '@vodacom/web-common';

import {
  CheckBox
} from '../components';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  handleUtagLinkEvent
} from 'helpers';

import {
  PrimaryButton
} from 'components';

import {
  DrupalProvider
} from 'providers';

import {
  withScreenViewTagging
} from 'hocs';

const ContentContainer = styled(Text)`
  img {
    max-width: 100%;
  }
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: 100%;
  background-color: ${CustomColors.White};
  padding: 14px 0 20px;
`;

const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100%;
  background-color: ${CustomColors.White};
  padding: 32px 0 5px;
`;

const OnboardingLandingUI = props => {

  let completedLanding = JourneyProvider.get('Common', 'acceptedLanding');
  const ignoreSplashRedirect = sessionStorage.getItem('JourneyProvider_ignoreSplashRedirect') === 'true';

  const [
    state,
    setState
  ] = React.useState({
    currentPageIndex: 0,
    hasAccepted: false,
    landingPage: null
  });

  const mountedRef = React.useRef(true);

  const history = useHistory();

  React.useEffect(() => {

    mountedRef.current = true;

    if (completedLanding) {
      skipLanding();
    }

    if (!state.landingPage) {
      async function init() {
        await getLandingPage();
      }

      init();
    }

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const getLandingPage = async () => {

    const pagesResponse = await DrupalProvider.getCachedItem('pages', null, DrupalProvider.getPages);

    if (!mountedRef.current) {
      return;
    }

    if (!pagesResponse?.ok) {
      setState({
        ...state,
        hasError: true,
        error: pagesResponse?.error || new Error('Something went wrong')
      });

      return;
    }

    setState(prevState => ({
      ...prevState,
      landingPage: pagesResponse?.result?.find(page => page?.cmsPath === '/landing')?.content
    }));
  };

  const skipLanding = () => {

    if (ignoreSplashRedirect) {

      history.goBack();
      return;
    }
    history.replace('/home');
  };

  const generatePage = () => {

    return (

      <>

        <HeaderContainer>
        <HContainerH>

          <VContainer
            margin={'0 16px 16px 0'}>

            <Image
              src={Icons.VodacomLogo}
              width={'50px'}
              height={'50px'}
              margin={'0 17px 0 0'} />

          </VContainer>

          <Image
            src={Icons.ConnectU}
            width={'164px'}
            height={'40px'} />

        </HContainerH>
        </HeaderContainer>

        <VFillContainer
          flex={'1 0 auto'}
          padding={'95px 0 130px'}>

          <ContentContainer
            textAlign={'center'}
            dangerouslySetInnerHTML={
              { __html: state.landingPage }
            } />

        </VFillContainer>

        <Container>
          <HContainerH
            margin={'0 0 26px'}>

            <CheckBox
              width={'20px'}
              height={'20px'}
              borderRadius={'2px'}
              isChecked={state.hasAccepted}
              onClick={() => {

                setState(prevState => ({
                  ...prevState,
                  hasAccepted: !prevState.hasAccepted
                }));
              }} />

            <Text
              color={CustomColors.Grey9}
              fontSize={'16px'}
              textAlign={'center'}
              padding={'0 0 0 8px'}
              whiteSpace={'pre-wrap'}>

              {'I agree to the '}
            </Text>

            <Text
              color={CustomColors.Grey9}
              textDecoration={'underline'}
              fontSize={'16px'}
              textAlign={'center'}
              onClick={() => {

                history.push('/landing/legal');
              }}>

              {'terms & conditions'}
            </Text>

          </HContainerH>

        <PrimaryButton
          text={'Start browsing'}
          isEnabled={state.hasAccepted}
          width={'90%'}
          margin={'auto auto 0'}
          onClick={() => {

            JourneyProvider.set('Common', { acceptedLanding: true }, true);
            handleUtagLinkEvent({
              journey_event: 'journey_end',
              journey_step: 'cbu: connectu: first time customer: onboarding pages',
              journey_name: 'cbu: connectu: first time customer: onboarding',
              journey_type: 'onboarding'
            });

            history.push('/home');
          }}/>

        </Container>
      </>
    );
  };

  return (

    <VContainerH
      height={'100vh'}
      boxSizing={'border-box'}
      maxWidth={'375px'}
      padding={'0 16px'}
      margin={'0 auto'}>

      { !state.landingPage &&

        <VContainer
          margin={'auto'}>

          <Spinner
            margin={'auto'}
            color={CustomColors.Red1}
            size='200' />
        </VContainer>
      }

      { !!state.landingPage && generatePage(state.currentPageIndex)}
    </VContainerH>
  );
};

OnboardingLandingUI.pageName = 'cbu: connectu: first time customer: onboarding pages';
OnboardingLandingUI.tagViewData = {
  journey_event: 'journey_start',
  journey_step: 'cbu: connectu: first time customer: onboarding pages',
  journey_name: 'cbu: connectu: first time customer: onboarding',
  journey_type: 'onboarding'
};

export const OnboardingLanding = withScreenViewTagging(OnboardingLandingUI);
